import axios, { AxiosRequestConfig } from 'axios';
import PAGE_ROUTES, { API_ROUTES, getIp } from '../utils/constant';
import { auth } from '../firebase';
import HttpService from './Https-services';
import { toast } from 'react-toastify';
import React from 'react';
export type authDetailsType = {
  Token?: string;
  RefreshToken?: string;
  Email?: string;
  Name?: string;
  Phone?: string;
  roleId?: any;
  isDesabled?: any;
  id?: any;
  parent_accessToken?: any;
  parent_refreshToken?: any;
};

const baseUrl = process.env.REACT_APP_BASE_URL;
export const getCurrentAuth = () => {
  const localAuth = localStorage.getItem('auth');
  const auth: authDetailsType = localAuth
    ? JSON.parse(localStorage.getItem('auth') || '')
    : {};
  return auth;
};
export function setAuth(data: authDetailsType) {
  const oldAuth = getCurrentAuth();
  const tempAuth = { ...oldAuth, ...data };
  // tempAuth.Token = data.Token;
  tempAuth.Email = data.Email;

  localStorage.setItem('auth', JSON.stringify(tempAuth));
}

export const Logout = () => {
  localStorage.removeItem('auth');
  localStorage.removeItem('NotificationToken');
  window.location.href = '/login';
};
const axiosInstanceP = axios.create();
const refresh = async () => {
  const localAuth = getCurrentAuth();

  // const auth: any = localAuth
  // ? JSON.parse(localAuth || '')
  // : {};
  try {
    const currentUser = auth;
    const   ip = await getIp();
    if (currentUser) {
      const dataBody :any= {
        token: localAuth.parent_refreshToken,
      };
      if(ip){
        dataBody.ipAddress=ip
      }
      const response = await axios.post(
        `${baseUrl}${API_ROUTES.refreshToken}`,
        dataBody
      );
      const refreshedToken = response.data.data;

      // Handle the refreshed token as needed

      setAuth({
        parent_accessToken: refreshedToken,
      });
      return refreshedToken;
    }
  } catch (error: any) {
    // dispatch(logout());
    Logout();
    window.location.href = `${PAGE_ROUTES.LOGIN}`;
  }
};
// var auth = useTypedSelector(getAuthState, shallowEqual);
// const dispatch = useDispatch();
let flag = false;
const refreshExpiredTokenClosure = () => {
  let isCalled = false;
  let runningPromise: any = undefined;
  return () => {
    if (isCalled && flag) {
      return runningPromise;
    } else {
      isCalled = true;
      flag = true;
      runningPromise = refresh();

      return runningPromise;
    }
  };
};

// stores the function returned by refreshExpiredTokenClosure
function shouldRetry(config: any) {
  return config.retries.count < 3;
}
const refreshExpiredToken = refreshExpiredTokenClosure();

axiosInstanceP.interceptors.request.use(
  // @ts-ignore: Unreachable code error
  (config: AxiosRequestConfig) => {
    const auth = getCurrentAuth();
    if (!config.headers!['Authorization']) {
      config.headers!['Authorization'] = `bearer ${auth?.parent_accessToken}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
axiosInstanceP.interceptors.response.use(
  (response) => {
    return response;
  },

  async (error) => {
    error.config.retries = error.config.retries || {
      count: 0,
    };
    const originalRequest = error.config;

    // logout user's session if refresh token api responds 401 UNAUTHORIZED

    // if request fails with 401 UNAUTHORIZED status and 'Token has expired' as response message
    // then it calls the api to generate new access token

    if (error.response.status === 401 && shouldRetry(error.config)) {
      error.config.retries.count += 1;
      const updatedToken = await refreshExpiredToken();

      if (!updatedToken) {
        Logout();
        window.location.href = PAGE_ROUTES.LOGIN;
      } else {
        originalRequest.headers['Authorization'] = `bearer ${updatedToken}`;
        flag = false;
        return axiosInstanceP(originalRequest);
      }
    } else {
      toast.error(error.response.data.message, {
        position: 'bottom-right',
      });
    }
    return Promise.reject(error);
  }
);

export default axiosInstanceP;
